import Navbar from "../components/navbar/navbar";
import Footer from "../components/footer/footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AppLayout({ children }) {
  return (
    <div className="App overflow-hidden dark:bg-black font-['Poppins']">
      <Navbar />

      <main className="w-full lg:w-[70%] mx-auto dark:bg-black px-5 py-10 md:p-10 lg:px-20 lg:pb-28">
        {children}
      </main>

      <Footer />

      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </div>
  );
}